import type { ValidationItems } from '@kanda-libs/ks-component-ts';
import { URLS } from 'config';
import { type LocationDescriptor } from 'history';
import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { removeWhitespaceAndNewline } from 'utils';

export interface LoginContentHook {
  to: LocationDescriptor;
  onEmailBlur: () => void;
  emailValidation: ValidationItems;
  showSignup: boolean;
}

export default function useLoginContent(): LoginContentHook {
  const { getValues, setValue } = useFormContext();

  const [email, password] = useWatch({
    name: ['email', 'password'],
  });

  const onEmailBlur = () =>
    setValue('email', removeWhitespaceAndNewline(getValues('email')));

  const emailValidation: ValidationItems = useMemo(
    () => ({
      required: {
        value: true,
        message: 'Email address is required',
      },
      pattern: {
        value:
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'Email must be a valid email address',
      },
      validate: {
        value: () => getValues()?.email_validation !== 'invalid',
        message: 'Email address entered is invalid',
      },
    }),
    [getValues],
  );

  const to = useMemo(
    () => ({
      pathname: URLS.signUp,
      search: window.location.search,
      state: {
        email,
        password,
      },
    }),
    [email, password],
  );

  const showSignup = useMemo(() => false, []);

  return {
    to,
    onEmailBlur,
    emailValidation,
    showSignup,
  };
}
